import { FaCrown, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styles from "./UpgradeBottomSheet.module.css";



const UpgradeBottomSheet = ({

    open,

    title = "محدودیت نسخه رایگان",

    message,

    buttonText = "خرید اشتراک",

    cancelText = "بعداً",

    onClose,

    onConfirm,

}) => {

    const navigate = useNavigate();

    if (!open) return null;

    const handleConfirm = () => {

        if (onConfirm) {

            onConfirm();

            return;

        }

        onClose?.();

        navigate("/subscription");

    };

    return (

        <>

            <div

                className={styles.backdrop}

                onClick={onClose}

            />

            <div className={styles.sheet}>

                <div className={styles.handle} />

                <div className={styles.icon}>

                    <FaLock />

                </div>

                <h3 className={styles.title}>

                    {title}

                </h3>

                <p className={styles.message}>

                    {message}

                </p>

                <button

                    type="button"

                    className={styles.primaryButton}

                    onClick={handleConfirm}

                >

                    <FaCrown />

                    <span>

                        {buttonText}

                    </span>

                </button>

                <button

                    type="button"

                    className={styles.secondaryButton}

                    onClick={onClose}

                >

                    {cancelText}

                </button>

            </div>

        </>

    );

};

export default UpgradeBottomSheet;
